import { AbstractControl, FormArray, FormGroup } from '@angular/forms';

/** Recursively strip sync + async validators from an AbstractControl tree, including root form-level validators. One-way door. */
export function stripAllValidatorsRecursively(root: AbstractControl): void {
  if (!root) {
    return;
  }

  const strip = (control: AbstractControl): void => {
    control.clearValidators();
    control.clearAsyncValidators();
    control.updateValueAndValidity({ emitEvent: false });

    if (control instanceof FormGroup) {
      Object.values(control.controls).forEach(strip);
    } else if (control instanceof FormArray) {
      control.controls.forEach(strip);
    }
  };

  strip(root);
}
